<template>
    <InformeCard title="Procedencia" id="procedencia" name="procedencia" collapsable="true">
        <TotalAbonosPorCP :lista_id="lista_id"/>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";
    import TotalAbonosPorCP from "./components/TotalAbonosPorCP";

    export default {
        props: ['lista_id'],
        components: {
            InformeCard, TotalAbonosPorCP
        }
    }

</script>